import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const generateFlowAgentResponse = unaryStreamRpc({
  name: "generateFlowAgentResponse" as const,
  input: z.discriminatedUnion("type", [
    z.object({
      type: z.literal("new"),
      initialMessages: MessageSchema.array(),
      teamId: zExt.objectId(),
      existingFlow: z.object({ steps: z.array(z.any()), type: z.string() }),
    }),
    z.object({
      type: z.literal("continue"),
      threadId: zExt.objectId(),
      moreMessages: MessageSchema.array().optional(),
      existingFlow: z.object({ steps: z.array(z.any()), type: z.string() }),
    }),
  ]),
  output: z.object({
    threadId: z.string(),
    messages: MessageSchema.array(),
    flow: z.any(),
    isUpdatingFlow: z.boolean(),
  }),
});
